import React from "react";

export const SubjectTitle = ({ title }) => {
  return <h1 className="subject-title text-uppercase">{title}</h1>;
};
